import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import styled, { css } from 'styled-components';
import moment from 'moment';
import NotificationContext from "../hooks/NotificationContext";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRectangleXmark } from '@fortawesome/free-solid-svg-icons';

const styles = css`
margin: 0 auto;
display: flex;
flex-direction: column;
gap: 10px;
padding-top: 20px;
& .empty {
  width: 100%;
  text-align: center;
  font-style: italic;
}
`;

const notificationStyles = css`
  display: grid;
  grid-template-areas: 
   'time time time'
   'subject subject subject'
   'buttons buttons buttons';
  grid-template-columns: 1fr 1fr 1fr;
  gap: 3px;
  padding: 10px;
  border: 1px solid gray;
  border-radius: 3px;
  align-items: center;
  & .time {
    grid-area: time;
    font-size: 0.6em;
  }
  & .subject {
    padding-top: 3px;
    font-size: .8em;
    grid-area: subject;
  }
  & .buttons {
    padding-top: 10px;
    grid-area: buttons;
    font-size: 0.75em;
    justify-content: flex-start;
    display: flex;
    flex-wrap: wrap;
    flex-direction: row-reverse;
    gap: 3px;
  }

  & .bold {
    font-weight: bold;
  }
`
const Notification = styled(({ className, notification }) => {
  const { dismiss } = useContext(NotificationContext);
  const navigate = useNavigate();

  const NOTIFICATION_EVENTS = {
    personLeftGroup: 'personLeftGroup',
    newPersonInGroup: 'newPersonInGroup',
    newListInGroup: 'newListInGroup',
    invitationReceived: 'invitationReceived',
    invitationAccepted: 'invitationAccepted',
    listUpdated: 'listUpdated',
  }

  let subject = notification.subject;
  const buttons = [
    <button className='danger' onClick={() => dismiss(notification._id)}><FontAwesomeIcon icon = {faRectangleXmark}/></button>
  ]
  switch (notification.event) {
    case NOTIFICATION_EVENTS.invitationReceived:
      subject =
        <span>
          <span className = 'bold'>{`${notification.data.invitedBy.firstname} ${notification.data.invitedBy.lastname}`}</span>
          <span>{' invited you to join the '}</span>
          <span>{`${notification.data.list ? 'list ' : 'group '}`}</span>
          <span className='bold'>
            {`${notification.data.list?.name ?? notification.data.group?.name}`}
          </span>
        </span>;
      buttons.push(
        <button className='primary' onClick={() => window.location.href = `${notification.data.clientUrl}/${notification.data._id}`}>
          Accept Invitation
        </button>)
      break;
    case NOTIFICATION_EVENTS.newPersonInGroup:
      subject =
        <span>
          <span className='bold'>{`${notification.data.user.firstname} ${notification.data.user.lastname}`}</span>
          <span>{' has joined the group '}</span>
          <span className='bold'>
            {notification.data.group.name}
          </span>
        </span>;
      buttons.push(
        <button className='primary' onClick={() => navigate(`/groups/details/${notification.data.group._id}`)}>
          View Group
        </button>)
      break;
    default:
      break;
  }
  return (
    <div className={className}>
      <div className='time'>
        {moment(notification.createdOn).format('MMM D YYYY h:mm:ss A')}
      </div>
      <div className='subject'>
        {subject}
      </div>
      <div className='buttons'>
        {buttons.map((button, i) => <span key = {i}>{button}</span>)}
      </div>
    </div>
  )

})`${notificationStyles}`;

const Notifications = styled(({ className }) => {
  const { notifications } = useContext(NotificationContext);
  return (
    <div className={className}>
      {notifications.length
        ? notifications.map((notification, i) => <Notification key={i} notification={notification} />)
        : <div className='empty'>
          You have no unread notifications
        </div>
      }
    </div>
  )
})`${styles}`;

export default Notifications;